import { RadioGroupNew, RadioButtonNew } from "@octopusdeploy/design-system-components";
import type { TaskResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ExpandableFormSection, Summary } from "~/components/form";
import { TriggerSyncTask } from "./TriggerSyncTask";
type StepTemplateUpdatesProps = {
    isEnabled: boolean;
    isSyncEnabled: boolean;
    lastSyncedTask?: TaskResource<{}>;
    busy?: Promise<unknown> | boolean;
    onChange: (isEnabled: boolean) => void;
    onSyncClick: () => void;
};
export function StepTemplateUpdates({ isEnabled, lastSyncedTask, busy, isSyncEnabled, onChange, onSyncClick }: StepTemplateUpdatesProps) {
    const description = "Automatically receive latest fixes, improvements and steps to the step library";
    const label = "Step Template Updates";
    const name = "StepTemplateUpdates";
    return (<ExpandableFormSection key="IsAutomaticStepUpdatesEnabled" errorKey="IsAutomaticStepUpdatesEnabled" title={label} summary={isEnabled ? Summary.default("Enabled") : Summary.summary("Disabled")} help={description}>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={label} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name={name} hasDefaultMarker={true}/>
                <RadioButtonNew value={false} label="Disabled" name={name}/>
            </RadioGroupNew>

            <TriggerSyncTask isSyncEnabled={isSyncEnabled} lastSyncedTask={lastSyncedTask} busy={busy} onSyncClick={onSyncClick}/>
        </ExpandableFormSection>);
}
